import React from 'react';
import { Card } from 'primereact/card';

const StatCard = ({ title, value, subtitle, icon, colorClass }) => {
    return (
        <Card className={`stat-card ${colorClass}`}>
            <div className="stat-card-inner">
                <div className="stat-card-left">
                    <div className="stat-card-title">{title}</div>
                    <div className="stat-card-value">{value ?? '—'}</div>
                    <div className="stat-card-subtitle">{subtitle}</div>
                </div>
                <div className="stat-card-icon-wrap">
                    <i className={`pi ${icon}`} />
                </div>
            </div>
        </Card>
    );
};

export default StatCard;
